export default __webpack_public_path__ + "static/media/idea_people.599e429b.svg";